var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":_vm.pdfUrl,"height":"600"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }